module.exports = __webpack_public_path__ + "static/img/wealth_level_96.00b8a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_96.png
// module id = tfc2
// module chunks = 0